let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("eEyVs"), load("ffEVr"), load("6fix3")]).then(() => parcelRequire('aFpS8'));